import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type {
    ListBlockVolumesParams,
    ListBlockVolumesResponse,
} from '@xver/apis/v1/block-storage/model';
import { useActiveProjectScope } from '@xver/hooks/useActiveProject';
import { volumesRefetchInterval } from '@xver/utils/blockStorage';

export const BLOCK_VOLUMES_QUERY_KEY = 'apis.v1.block-storage.volumes.list';

interface UseBlockVolumesQueryOptions {
    params?: ListBlockVolumesParams;
    /** Project to list from; defaults to the active project. */
    projectId?: string;
    /** Pass false while the caller has no Block storage access, so no request is made. */
    enabled?: boolean;
}

/** Polls every 3 s while any volume is transitional, else every 15 s. */
export function useBlockVolumesQuery({
    params,
    projectId,
    enabled = true,
}: UseBlockVolumesQueryOptions = {}) {
    const { activeProjectId, isResolved } = useActiveProjectScope();

    return useQuery<ListBlockVolumesResponse>({
        queryKey: [BLOCK_VOLUMES_QUERY_KEY, projectId ?? activeProjectId, params],
        queryFn: () => Endpoints.v1.BlockStorage.listVolumes(params, projectId),
        enabled: isResolved && enabled,
        refetchInterval: (query) => volumesRefetchInterval(query.state.data?.data ?? []),
    });
}
